import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";
import AuthService from "../../services/auth.service";
import { Logo } from "../../assets/img";
import {
  MdOutlineLock,
  MdVisibility,
  MdVisibilityOff,
  MdArrowForward,
  MdArrowBack,
} from "react-icons/md";

const Reset = () => {
  const { code: codeParam } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  });
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleVisibility = () => setIsVisible(!isVisible);

  const handleChange = (value, target) => {
    setForm((prev) => ({ ...prev, [target]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { password, confirmPassword } = form;

    if (!password || !confirmPassword) {
      toast.error("Por favor complete ambos campos");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Las contraseñas no coinciden");
      return;
    }

    if (password.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    setLoading(true);
    try {
      const response = await AuthService.resetPassword({
        code: codeParam,
        password,
        password_confirmation: confirmPassword,
      });

      if (response && response.result === true) {
        toast.success("Su contraseña ha sido actualizada exitosamente");
        navigate("/");
      } else {
        toast.error("No se pudo actualizar la contraseña. Intente nuevamente.");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.error ||
        "Hubo un error al actualizar la contraseña";
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#F4F4F2] font-sans">
      <div className="w-[88%] max-w-[400px] bg-white px-6 pt-8 pb-10 rounded-3xl shadow-[0_4px_12px_rgba(0,0,0,0.06)] flex flex-col">
        <img
          src={Logo}
          alt="Bórralo Logo"
          className="w-[140px] h-[140px] object-contain self-center mt-2 mb-2 bg-transparent"
        />

        <div className="flex flex-col items-center mb-6 text-center">
          <h1 className="text-[#1D3B8B] font-black text-[20px] tracking-wide m-0">
            NUEVA CLAVE
          </h1>
          <p className="text-[#6B7280] text-[14px] mt-1 m-0">
            Cree una nueva contraseña para su cuenta
          </p>
        </div>

        <form className="w-full" onSubmit={handleSubmit}>
          <div className="flex flex-row items-center border border-[#F3F4F6] bg-[#FAFAFA] rounded-xl mb-4 h-14 px-4">
            <MdOutlineLock size={22} className="text-[#1D3B8B] mr-3 shrink-0" />
            <input
              type={isVisible ? "text" : "password"}
              placeholder="Nueva Contraseña"
              className="flex-1 bg-transparent border-none outline-none text-[15px] text-[#111827] placeholder-[#9CA3AF] h-full"
              value={form.password}
              onChange={(e) => handleChange(e.target.value, "password")}
            />
            <button
              type="button"
              onClick={toggleVisibility}
              className="p-2 ml-2 bg-transparent border-none cursor-pointer flex items-center justify-center shrink-0"
            >
              {isVisible ? (
                <MdVisibility size={22} className="text-[#6B7280]" />
              ) : (
                <MdVisibilityOff size={22} className="text-[#6B7280]" />
              )}
            </button>
          </div>

          <div className="flex flex-row items-center border border-[#F3F4F6] bg-[#FAFAFA] rounded-xl mb-6 h-14 px-4">
            <MdOutlineLock size={22} className="text-[#1D3B8B] mr-3 shrink-0" />
            <input
              type={isVisible ? "text" : "password"}
              placeholder="Confirmar Contraseña"
              className="flex-1 bg-transparent border-none outline-none text-[15px] text-[#111827] placeholder-[#9CA3AF] h-full"
              value={form.confirmPassword}
              onChange={(e) => handleChange(e.target.value, "confirmPassword")}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#1D3B8B] rounded-xl h-14 flex flex-row justify-center items-center relative mb-5 border-none cursor-pointer opacity-100 disabled:opacity-70 transition-opacity"
          >
            <span className="font-bold text-white text-[16px]">
              {loading ? "Actualizando..." : "Actualizar Contraseña"}
            </span>
            <MdArrowForward size={20} className="text-white absolute right-5" />
          </button>
        </form>

        <div className="flex justify-center border-t border-[#F3F4F6] pt-5">
          <Link
            to="/"
            className="flex items-center text-[#1D3B8B] font-bold text-[14px] no-underline hover:underline"
          >
            <MdArrowBack size={18} className="mr-1" />
            Volver al Inicio de Sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Reset;
